import { render, staticRenderFns } from "./TimeLineEventBlurb.vue?vue&type=template&id=60c27d76&scoped=true&"
import script from "./TimeLineEventBlurb.vue?vue&type=script&lang=js&"
export * from "./TimeLineEventBlurb.vue?vue&type=script&lang=js&"
import style0 from "./TimeLineEventBlurb.vue?vue&type=style&index=0&id=60c27d76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c27d76",
  null
  
)

component.options.__file = "TimeLineEventBlurb.vue"
export default component.exports